export const checkboxCustomization = () => ({
  MuiCheckbox: {
    defaultProps: {
      disableRipple: true,
    },
    // styleOverrides: {
    //   root: {
    //     padding: 0,
    //     '&.Mui-checked': {
    //       color: '#333333',
    //     },
    //     '&.Mui-disabled': {
    //       color: 'rgba(0, 0, 0, 0.38)',
    //     },
    //   },
    // },
  },
});
